import { useCallback } from 'react';
import CopyLinkOutline from '@simplywallst/ui-core/icons/CopyLinkOutline';
import { Text, Button } from '@simplywallst/ui-core';
import { useSnackbar } from '@/features/snackbar';
import {
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
} from 'react-share';
import { ShareSection } from './styled';
import { SWS_HOST } from '@/constants';

const SharingSocialButtons = () => {
  const { addSnackbar } = useSnackbar();
  const sharedURL = `${SWS_HOST}${window.location.pathname}`;
  const copyLinkToClipboard = useCallback(async () => {
    addSnackbar({
      message: 'Link copied',
      type: 'positive',
      lifeTime: 3000,
    });
    return await navigator.clipboard.writeText(sharedURL);
  }, [addSnackbar]);

  return (
    <ShareSection alignItem="center">
      {RUNTIME_ENV !== 'server' ? (
        <>
          <Text color="noirRGBA" opacity={0.5} typography="tiny">
            Share
          </Text>
          <FacebookShareButton url={sharedURL}>
            <FacebookIcon size={24} round bgStyle={{ fill: '#2F74E3' }} />
          </FacebookShareButton>
          <LinkedinShareButton url={sharedURL}>
            <LinkedinIcon
              size={24}
              borderRadius={8}
              bgStyle={{ fill: '#2766BC' }}
            />
          </LinkedinShareButton>
          <TwitterShareButton url={sharedURL}>
            <TwitterIcon
              size={28}
              bgStyle={{ fill: 'white' }}
              iconFillColor="#48A0EB"
            />
          </TwitterShareButton>
          <Button
            onClick={copyLinkToClipboard}
            styleType="passiveReverse"
            alignIcon="left"
          >
            <CopyLinkOutline />
            Copy Link
          </Button>
        </>
      ) : null}
    </ShareSection>
  );
};

export default SharingSocialButtons;
